import { SYSBaseElement, html } from "../../../../../../_ovlclient/src"

import { T } from "../../../../../../_ovlclient/src/textapi"
import { FileGet } from "../../../../../../_ovlclient/src/global/globalapi"

export type FileList = {
  files: File[]
}

export type FileType =
  | "MainAttachment"
  | "PartnerAttachment"
  | "Order"
  | "OrderAttachment"
  | "StepConfirmation"
  | "StepAVOR"
  | "StepProduction"
  | "StepDelivery"
  | "Quotation"
  | "Invoice"
  | "DPInvoice"
  | "Test"

export type File = {
  type: FileType
  fileName: string
}

type PopupState = {
  activeFilePopup: string
}
export type TogglePDFPopupState = {
  key: string
  obj: PopupState
}

export class CompFileList extends SYSBaseElement {
  props: any
  fileData: { fileList: File[]; title: string }
  // init() {
  // }
  handleFile(e: Event, fileName: string, fileType: FileType) {
    e.preventDefault()
    e.stopPropagation()
    let docNum =
      this.state.app.screens.DATOrder.orderDetailFormState.selectedOrder
    FileGet({
      ext: "",
      id1: fileName,
      cat: fileType,
      id2: docNum,
    })
  }

  async getUI() {
    this.fileData = this.props(this.state)
    let title
    if (!this.fileData.title) {
      title = T("GENFileName")
    } else {
      title = this.fileData.title
    }

    if (!this.fileData.fileList) {
      return null
    }
    return html`
      <table class="fd-table ">
        <thead class="fd-table__header">
          <tr class="fd-table__row">
            <th class="fd-table__cell " scope="col">${title}</th>
          </tr>
        </thead>
        <tbody class="fd-table__body">
          ${this.fileData.fileList.map((f) => {
            if (f.type === "MainAttachment") {
              let endNames = f.fileName.split(".")
              let toCheck = endNames[endNames.length - 2]
              let toCheckEnd = toCheck.substring(toCheck.length - 3)
              if (
                !(
                  this.state.ovl.session.Language.toLowerCase() ===
                    toCheckEnd.substring(1).toLowerCase() ||
                  toCheckEnd.indexOf("_") < 0
                )
              ) {
                return html`<!---->`
              }
            }

            return html`
              <tr class="fd-table__row">
                <td class="fd-table__cell ">
                  <a
                    href=""
                    @click=${(e) => {
                      this.handleFile(e, f.fileName, f.type)
                    }}
                    class="fd-link fd-has-font-weight-semi"
                    >${f.fileName}</a
                  >
                </td>
              </tr></tr>
            `
          })}
        </tbody>
      </table>
    `
  }
}
